export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])}
        }
      },
      "en": {
        "labels": {
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])}
        }
      }
    }
  })
}